





















































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';

import AddressListItem from './address-list-item.vue';
import { LocationValue } from '../store/types';
import axios from 'axios';

let uniqueId = 0;

@Component({
  components: {
    AddressListItem,
  },
})
export default class extends Vue {
  public $refs!: {
    input: HTMLInputElement;
  };

  @Prop({
    default: () => {
      return `covid-google-location-input-${uniqueId++}`;
    },
  })
  public id!: string;
  private localValue = '';

  private predictions: any[] = [];
  private debounceTimer: any = 0;
  private inputEl!: HTMLInputElement;

  private get availablePrediictions() {
    return this.predictions.slice(0, 5);
  }

  public mounted() {
    this.inputEl = this.$refs.input;
  }

  private async getProdictions(query: string): Promise<any[]> {
    return new Promise(resolve => {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(async () => {
        try {
          const response = await axios.get(
            `https://api.mapbox.com/geocoding/v5/mapbox.places/${query}.json`,
            {
              params: {
                access_token: process.env.VUE_APP_MAPBOX_TOKEN,
              },
            },
          );

          resolve(
            (response.data?.features || []).filter(
              (x: any) =>
                (x.place_type || []).indexOf('place') >= 0 ||
                (x.place_type || []).indexOf('address') >= 0,
            ),
          );
        } catch {
          resolve([]);
        }
      }, 300);
    });
  }

  private async onInputChange() {
    this.localValue = this.inputEl.value;
    this.predictions = await this.getProdictions(this.localValue);
  }

  @Emit('change')
  private onChangeEmit(value: any) {
    return value;
  }

  // private initGooglePlacesAutocomplete(input: HTMLInputElement) {
  // // @ts-ignore
  // this.$gmapApiPromiseLazy().then(() => {
  //   this.$autocomplete = new window.google.maps.places.AutocompleteService();
  // });
  // }

  private complete(value: any) {
    if (!value) {
      return;
    }
    this.localValue = value.place_name;

    //   const service = new window.google.maps.places.PlacesService(this.inputEl);
    //   this.predictions = [];
    //   service.getDetails(
    //     {
    //       placeId: value.place_id,
    //     },
    //     (place, status) => {
    //       if (status === window.google.maps.places.PlacesServiceStatus.OK) {
    //         this.localValue = place.formatted_address || place.name;
    this.onChangeEmit(value);
    //       }
    //     },
    //   );
  }
}
